<script setup lang="ts">
import { BaseButton, BaseDialog, BaseIcon } from "@lunagoai/vue-ui";

defineProps<{
  visible: boolean;
  title: string;
  message: string;
  laterLabel: string;
  updateLabel: string;
  busy?: boolean;
}>();

const emit = defineEmits<{
  "update:visible": [value: boolean];
  "update-now": [];
}>();
</script>

<template>
  <BaseDialog
    :visible="visible"
    :closable="false"
    :close-on-escape="false"
    :dismissable-mask="false"
    max-width="sm"
    @update:visible="emit('update:visible', $event)"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <span class="grid size-9 place-items-center rounded-xl bg-primary/10 text-primary" aria-hidden="true">
          <BaseIcon name="Info" :size="20" />
        </span>
        <span>{{ title }}</span>
      </div>
    </template>
    <p class="text-sm leading-6 text-ui-muted">{{ message }}</p>
    <template #footer>
      <BaseButton variant="secondary" :disabled="busy" @click="emit('update:visible', false)">{{ laterLabel }}</BaseButton>
      <BaseButton variant="primary" :loading="busy" :disabled="busy" @click="emit('update-now')">{{ updateLabel }}</BaseButton>
    </template>
  </BaseDialog>
</template>
